import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

/**
 * 랜딩 헤드라인 `Stay in Flow` — D1 §7. 로고가 아니다(D148 ⑦).
 *
 * 「Flow」는 accent-600(3.17:1)이다. 큰 글자 기준 3:1을 넘는 단계이고, accent-500의 대비 예외는 로고 심볼에만 있다.
 */
export function LandingHeadline({ className, ...props }: ComponentProps<'h1'>) {
  return (
    <h1
      className={cn(
        'font-display text-display tracking-display gap-row flex flex-wrap items-center justify-center font-bold',
        className,
      )}
      {...props}
    >
      <span className="text-brand-600">Stay in</span>
      <span className="text-accent-600">Flow</span>
    </h1>
  );
}
